import { getPlanets } from "./planetsSource";
import { saveToFirebase, readFromFirebase } from "./firebaseModel";

const model = {
  username: "",
  emailAddress: null,
  planetsList: [],
  suspense: false,
  currentPlanet: null,
  currentScore: { total: 0, previous: [] },
  currentRound: null,
  guessedValues: {
    size: null,
    distance: null,
  },
  PersonalLeaderboardPromiseState: [],
  settings: { music: true, darkMode: true },
  OGplanetsList: [],

  async doSearch() {
    if (this.planetsList.length === 0) {
      await this.APICall();
    }
    if (this.planetsList.length <= 3) {
      this.planetsList = this.planetsList.concat(this.OGplanetsList);
    }
  },

  async APICall() {
    this.suspense = true;
    try {
      this.planetsList = await getPlanets();
      this.OGplanetsList = [...this.planetsList];
    } catch (error) {
      console.error("Error retrieving planets list:", error);
      const storedPlanetsList = localStorage.getItem("planetsList");
      if (storedPlanetsList) {
        this.planetsList = JSON.parse(storedPlanetsList);
      } else {
        console.error("API not reachable and no stored data");
      }
    }

    this.suspense = false;
    localStorage.setItem("planetsList", JSON.stringify(this.planetsList));
  },

  async setEmailAddress(emailAddress) {
    this.emailAddress = emailAddress;
  },

  async setUsername(userName) {
    this.username = userName;
  },

  extractPlanet() {
    this.guessedValues = {
      size: 7972.5,
      distance: 0,
    };
    this.currentPlanet = this.planetsList.shift();
  },

  setDistance(lightyears) {
    this.guessedValues.distance = lightyears;
  },
  setSize(km) {
    this.guessedValues.size = km;
  },

  updateScore(score) {
    this.currentScore.total += score;
  },

  addPreviousRound(planet, score) {
    this.currentScore.previous.push({
      image: planet.imgSrc.img,
      name: planet.name,
      score: score,
    });
  },

  nextRound() {
    this.currentRound += 1;
  },

  resetModel() {
    this.username = "";
    this.emailAddress = null;
    this.planetsList = [];
    this.suspense = false;
    this.currentPlanet = null;
    this.currentScore.total = 0;
    this.currentScore.previous = [];
    this.guessedValues = { size: null, distance: null };
    this.PersonalLeaderboardPromiseState = [];
    this.GeneralLeaderboardPromiseState = [];
    this.settings = { music: true, darkMode: true };
  },

  async saveScoreOnLeaderboard() {
    const scoreData = {
      id: this.PersonalLeaderboardPromiseState.length + 1,
      score: this.currentScore.total,
      date: new Date(),
      position: null,
      username: this.username,
    };

    this.PersonalLeaderboardPromiseState.push(scoreData);
    saveToFirebase(model);
  },

  resetGame() {
    this.currentScore = { total: 0, previous: [] };
    this.currentRound = 1;
    this.currentPlanet = null;
    this.guessedValues = {
      size: null,
      distance: null,
    };
  },

  initializeGame() {
    this.currentRound = 1;
    this.guessedValues = {
      size: 7972.5,
      distance: 0,
    };
  },
};
export { model };
readFromFirebase(model);
